import { defineComponent as v, openBlock as t, createElementBlock as a, mergeProps as k, createCommentVNode as r, renderSlot as b, createElementVNode as i, computed as m, normalizeClass as $, toDisplayString as u, Fragment as y, renderList as g, createBlock as S, Teleport as T, createVNode as z, Transition as q, withCtx as C, withModifiers as L, createTextVNode as w, ref as V, TransitionGroup as D, normalizeStyle as I, resolveComponent as N } from "vue";
import { useRoute as R } from "vue-router";
const P = ["disabled", "type"], K = {
  key: 0,
  class: "cf-button__spinner",
  "aria-hidden": "true"
}, E = {
  key: 1,
  class: "cf-button__icon"
}, A = { class: "cf-button__label" }, x = /* @__PURE__ */ v({
  __name: "CfButton",
  props: {
    variant: { default: "primary" },
    size: { default: "md" },
    type: { default: "button" },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    block: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (s, c) => (t(), a("button", k({
      class: ["cf-button", `cf-button--${e.variant}`, `cf-button--${e.size}`, { "cf-button--loading": e.loading, "cf-button--block": e.block }],
      disabled: e.disabled || e.loading,
      type: e.type
    }, s.$attrs), [
      e.loading ? (t(), a("span", K)) : r("", !0),
      s.$slots.icon && !e.loading ? (t(), a("span", E, [
        b(s.$slots, "icon", {}, void 0, !0)
      ])) : r("", !0),
      i("span", A, [
        b(s.$slots, "default", {}, void 0, !0)
      ])
    ], 16, P));
  }
}), h = (e, s) => {
  const c = e.__vccOpts || e;
  for (const [o, f] of s)
    c[o] = f;
  return c;
}, it = /* @__PURE__ */ h(x, [["__scopeId", "data-v-98380121"]]), F = ["for"], G = { class: "cf-input__field-wrap" }, H = {
  key: 0,
  class: "cf-input__affix cf-input__affix--prefix"
}, O = ["id", "value", "type", "placeholder", "disabled", "required", "autocomplete"], W = {
  key: 1,
  class: "cf-input__affix cf-input__affix--suffix"
}, j = {
  key: 1,
  class: "cf-input__error",
  role: "alert"
}, J = {
  key: 2,
  class: "cf-input__hint"
}, Q = /* @__PURE__ */ v({
  __name: "CfInput",
  props: {
    modelValue: {},
    label: {},
    type: { default: "text" },
    placeholder: {},
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    error: {},
    hint: {},
    autocomplete: {},
    id: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const s = e, c = m(() => s.id ?? `cf-input-${Math.random().toString(36).slice(2)}`);
    return (o, f) => (t(), a("div", {
      class: $(["cf-input-wrapper", { "cf-input-wrapper--error": !!e.error, "cf-input-wrapper--disabled": e.disabled }])
    }, [
      e.label ? (t(), a("label", {
        key: 0,
        for: c.value,
        class: "cf-input__label"
      }, u(e.label), 9, F)) : r("", !0),
      i("div", G, [
        o.$slots.prefix ? (t(), a("span", H, [
          b(o.$slots, "prefix", {}, void 0, !0)
        ])) : r("", !0),
        i("input", k({
          id: c.value,
          value: e.modelValue,
          type: e.type,
          placeholder: e.placeholder,
          disabled: e.disabled,
          required: e.required,
          autocomplete: e.autocomplete,
          class: ["cf-input__field", { "cf-input__field--prefix": o.$slots.prefix, "cf-input__field--suffix": o.$slots.suffix }]
        }, o.$attrs, {
          onInput: f[0] || (f[0] = (d) => o.$emit("update:modelValue", d.target.value))
        }), null, 16, O),
        o.$slots.suffix ? (t(), a("span", W, [
          b(o.$slots, "suffix", {}, void 0, !0)
        ])) : r("", !0)
      ]),
      e.error ? (t(), a("span", j, u(e.error), 1)) : e.hint ? (t(), a("span", J, u(e.hint), 1)) : r("", !0)
    ], 2));
  }
}), nt = /* @__PURE__ */ h(Q, [["__scopeId", "data-v-0bb8ec85"]]), U = ["for"], X = { class: "cf-select__field-wrap" }, Y = ["id", "value", "disabled", "required"], Z = ["selected"], ee = ["value"], te = {
  key: 1,
  class: "cf-select__error",
  role: "alert"
}, ae = /* @__PURE__ */ v({
  __name: "CfSelect",
  props: {
    modelValue: {},
    options: {},
    label: {},
    placeholder: {},
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    error: {},
    id: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const s = e, c = m(() => s.id ?? `cf-select-${Math.random().toString(36).slice(2)}`);
    return (o, f) => (t(), a("div", {
      class: $(["cf-select-wrapper", { "cf-select-wrapper--error": !!e.error }])
    }, [
      e.label ? (t(), a("label", {
        key: 0,
        for: c.value,
        class: "cf-select__label"
      }, u(e.label), 9, U)) : r("", !0),
      i("div", X, [
        i("select", k({
          id: c.value,
          value: e.modelValue,
          disabled: e.disabled,
          required: e.required,
          class: "cf-select__field"
        }, o.$attrs, {
          onChange: f[0] || (f[0] = (d) => o.$emit("update:modelValue", d.target.value))
        }), [
          e.placeholder ? (t(), a("option", {
            key: 0,
            value: "",
            selected: !e.modelValue
          }, u(e.placeholder), 9, Z)) : r("", !0),
          (t(!0), a(y, null, g(e.options, (d) => (t(), a("option", {
            key: typeof d == "string" ? d : d.value,
            value: typeof d == "string" ? d : d.value
          }, u(typeof d == "string" ? d : d.label), 9, ee))), 128))
        ], 16, Y),
        f[1] || (f[1] = i("span", {
          class: "cf-select__chevron",
          "aria-hidden": "true"
        }, "▾", -1))
      ]),
      e.error ? (t(), a("span", te, u(e.error), 1)) : r("", !0)
    ], 2));
  }
}), ct = /* @__PURE__ */ h(ae, [["__scopeId", "data-v-9140f16a"]]), le = {
  key: 0,
  class: "cf-card__header"
}, se = { class: "cf-card__title" }, oe = { class: "cf-card__body" }, ie = {
  key: 1,
  class: "cf-card__footer"
}, ne = /* @__PURE__ */ v({
  __name: "CfCard",
  props: {
    variant: { default: "default" },
    title: {},
    clickable: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e) {
    return (s, c) => (t(), a("div", k({
      class: ["cf-card", `cf-card--${e.variant}`, { "cf-card--clickable": e.clickable }]
    }, s.$attrs, {
      onClick: c[0] || (c[0] = (o) => e.clickable ? s.$emit("click", o) : void 0)
    }), [
      s.$slots.header || e.title ? (t(), a("div", le, [
        b(s.$slots, "header", {}, () => [
          i("h3", se, u(e.title), 1)
        ], !0)
      ])) : r("", !0),
      i("div", oe, [
        b(s.$slots, "default", {}, void 0, !0)
      ]),
      s.$slots.footer ? (t(), a("div", ie, [
        b(s.$slots, "footer", {}, void 0, !0)
      ])) : r("", !0)
    ], 16));
  }
}), dt = /* @__PURE__ */ h(ne, [["__scopeId", "data-v-920cedcd"]]), ce = /* @__PURE__ */ v({
  __name: "CfBadge",
  props: {
    variant: { default: "neutral" },
    size: { default: "md" }
  },
  setup(e) {
    return (s, c) => (t(), a("span", {
      class: $(["cf-badge", `cf-badge--${e.variant}`, `cf-badge--${e.size}`])
    }, [
      b(s.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), de = /* @__PURE__ */ h(ce, [["__scopeId", "data-v-f21296a9"]]), re = ["aria-labelledby"], ue = { class: "cf-modal__header" }, fe = ["id"], be = { class: "cf-modal__body" }, _e = {
  key: 0,
  class: "cf-modal__footer"
}, ve = /* @__PURE__ */ v({
  __name: "CfModal",
  props: {
    modelValue: { type: Boolean },
    title: {},
    size: { default: "md" },
    closeable: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "close"],
  setup(e, { emit: s }) {
    const c = s, o = m(() => `cf-modal-title-${Math.random().toString(36).slice(2)}`);
    function f() {
      c("update:modelValue", !1), c("close");
    }
    return (d, l) => (t(), S(T, { to: "body" }, [
      z(q, { name: "cf-modal" }, {
        default: C(() => [
          e.modelValue ? (t(), a("div", {
            key: 0,
            class: "cf-modal-overlay",
            onClick: l[0] || (l[0] = L((_) => e.closeable && f(), ["self"]))
          }, [
            i("div", {
              role: "dialog",
              "aria-modal": !0,
              "aria-labelledby": o.value,
              class: $(["cf-modal", `cf-modal--${e.size}`])
            }, [
              i("div", ue, [
                i("h2", {
                  id: o.value,
                  class: "cf-modal__title"
                }, [
                  b(d.$slots, "title", {}, () => [
                    w(u(e.title), 1)
                  ], !0)
                ], 8, fe),
                e.closeable ? (t(), a("button", {
                  key: 0,
                  class: "cf-modal__close",
                  "aria-label": "Close",
                  onClick: f
                }, " ✕ ")) : r("", !0)
              ]),
              i("div", be, [
                b(d.$slots, "default", {}, void 0, !0)
              ]),
              d.$slots.footer ? (t(), a("div", _e, [
                b(d.$slots, "footer", {}, void 0, !0)
              ])) : r("", !0)
            ], 10, re)
          ])) : r("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), rt = /* @__PURE__ */ h(ve, [["__scopeId", "data-v-8a9f4290"]]), he = {
  class: "cf-toast-container",
  "aria-live": "polite",
  "aria-atomic": "false"
}, $e = { class: "cf-toast__icon" }, me = { class: "cf-toast__content" }, ye = {
  key: 0,
  class: "cf-toast__title"
}, ge = { class: "cf-toast__message" }, ke = ["onClick"], pe = /* @__PURE__ */ v({
  __name: "CfToast",
  setup(e, { expose: s }) {
    const c = V([]), o = {
      success: "✓",
      error: "✕",
      warning: "⚠",
      info: "ℹ"
    };
    function f(l) {
      const _ = Math.random().toString(36).slice(2);
      c.value.push({ ...l, id: _ });
      const n = l.duration ?? 4e3;
      return n > 0 && setTimeout(() => d(_), n), _;
    }
    function d(l) {
      const _ = c.value.findIndex((n) => n.id === l);
      _ !== -1 && c.value.splice(_, 1);
    }
    return s({ add: f, dismiss: d }), (l, _) => (t(), S(T, { to: "body" }, [
      i("div", he, [
        z(D, { name: "cf-toast" }, {
          default: C(() => [
            (t(!0), a(y, null, g(c.value, (n) => (t(), a("div", {
              key: n.id,
              class: $(["cf-toast", `cf-toast--${n.type}`]),
              role: "alert"
            }, [
              i("span", $e, u(o[n.type]), 1),
              i("div", me, [
                n.title ? (t(), a("p", ye, u(n.title), 1)) : r("", !0),
                i("p", ge, u(n.message), 1)
              ]),
              i("button", {
                class: "cf-toast__close",
                "aria-label": "Dismiss",
                onClick: (B) => d(n.id)
              }, "✕", 8, ke)
            ], 2))), 128))
          ]),
          _: 1
        })
      ])
    ]));
  }
}), ut = /* @__PURE__ */ h(pe, [["__scopeId", "data-v-cb8dacdc"]]), Ce = ["aria-label", "aria-valuenow"], we = {
  key: 0,
  class: "cf-progress__header"
}, Be = {
  key: 0,
  class: "cf-progress__label"
}, Ve = {
  key: 1,
  class: "cf-progress__value"
}, Ie = /* @__PURE__ */ v({
  __name: "CfProgressBar",
  props: {
    value: {},
    label: {},
    showValue: { type: Boolean, default: !1 },
    color: { default: "var(--cf-blue)" },
    size: { default: "md" },
    animate: { type: Boolean, default: !0 },
    transitionDuration: { default: 600 }
  },
  setup(e) {
    const s = e, c = m(() => Math.min(100, Math.max(0, s.value))), o = m(() => s.color ? s.color : c.value >= 80 ? "#2d6a4f" : c.value >= 50 ? "var(--cf-blue-mid)" : "var(--cf-yellow)"), f = m(() => ({ sm: "4px", md: "8px", lg: "16px" })[s.size]);
    return (d, l) => (t(), a("div", {
      class: "cf-progress",
      "aria-label": e.label,
      role: "progressbar",
      "aria-valuenow": e.value,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }, [
      e.label || e.showValue ? (t(), a("div", we, [
        e.label ? (t(), a("span", Be, u(e.label), 1)) : r("", !0),
        e.showValue ? (t(), a("span", Ve, u(e.value) + "%", 1)) : r("", !0)
      ])) : r("", !0),
      i("div", {
        class: "cf-progress__track",
        style: I({ height: f.value })
      }, [
        i("div", {
          class: "cf-progress__bar",
          style: I({
            width: `${c.value}%`,
            backgroundColor: o.value,
            transition: e.animate ? `width ${e.transitionDuration}ms ease` : "none"
          })
        }, null, 4)
      ], 4)
    ], 8, Ce));
  }
}), ft = /* @__PURE__ */ h(Ie, [["__scopeId", "data-v-c869d84b"]]), Se = ["aria-label"], ze = { class: "cf-sidebar__header" }, Me = {
  key: 0,
  class: "cf-sidebar__brand"
}, Te = ["aria-label"], qe = { class: "cf-sidebar__nav" }, Le = {
  class: "cf-sidebar__icon",
  "aria-hidden": "true"
}, De = {
  key: 0,
  class: "cf-sidebar__label"
}, Ne = {
  key: 0,
  class: "cf-sidebar__footer"
}, Re = /* @__PURE__ */ v({
  __name: "CfSidebar",
  props: {
    items: {},
    collapsed: { type: Boolean, default: !1 },
    brand: {},
    ariaLabel: { default: "Main navigation" }
  },
  emits: ["update:collapsed"],
  setup(e) {
    const s = R();
    function c(o) {
      return s.path === o || s.path.startsWith(o + "/");
    }
    return (o, f) => {
      const d = N("RouterLink");
      return t(), a("nav", {
        class: $(["cf-sidebar", { "cf-sidebar--collapsed": e.collapsed }]),
        "aria-label": e.ariaLabel
      }, [
        i("div", ze, [
          b(o.$slots, "header", {}, () => [
            e.collapsed ? r("", !0) : (t(), a("span", Me, u(e.brand), 1))
          ], !0),
          i("button", {
            class: "cf-sidebar__toggle",
            "aria-label": e.collapsed ? "Expand sidebar" : "Collapse sidebar",
            onClick: f[0] || (f[0] = (l) => o.$emit("update:collapsed", !e.collapsed))
          }, u(e.collapsed ? "→" : "←"), 9, Te)
        ]),
        i("ul", qe, [
          (t(!0), a(y, null, g(e.items, (l) => (t(), a("li", {
            key: l.to,
            class: "cf-sidebar__item"
          }, [
            z(d, {
              to: l.to,
              class: $(["cf-sidebar__link", { "cf-sidebar__link--active": c(l.to) }]),
              "aria-label": e.collapsed ? l.label : void 0,
              title: e.collapsed ? l.label : void 0
            }, {
              default: C(() => [
                i("span", Le, u(l.icon), 1),
                e.collapsed ? r("", !0) : (t(), a("span", De, u(l.label), 1)),
                l.badge && !e.collapsed ? (t(), S(de, {
                  key: 1,
                  variant: "danger",
                  size: "sm"
                }, {
                  default: C(() => [
                    w(u(l.badge), 1)
                  ]),
                  _: 2
                }, 1024)) : r("", !0)
              ]),
              _: 2
            }, 1032, ["to", "class", "aria-label", "title"])
          ]))), 128))
        ]),
        o.$slots.footer ? (t(), a("div", Ne, [
          b(o.$slots, "footer", {}, void 0, !0)
        ])) : r("", !0)
      ], 10, Se);
    };
  }
}), bt = /* @__PURE__ */ h(Re, [["__scopeId", "data-v-f497cf7f"]]), Pe = { class: "cf-table-wrapper" }, Ke = {
  key: 0,
  class: "cf-table__toolbar"
}, Ee = { class: "cf-table__scroll" }, Ae = ["aria-label"], xe = { class: "cf-table__head" }, Fe = ["onClick"], Ge = {
  key: 0,
  class: "cf-table__sort-icon"
}, He = {
  key: 0,
  class: "cf-table__th"
}, Oe = { class: "cf-table__body" }, We = {
  key: 0,
  class: "cf-table__row cf-table__row--loading"
}, je = ["colspan"], Je = {
  key: 1,
  class: "cf-table__row cf-table__row--empty"
}, Qe = ["colspan"], Ue = ["onClick"], Xe = {
  key: 0,
  class: "cf-table__td"
}, Ye = {
  key: 1,
  class: "cf-table__pagination"
}, Ze = { class: "cf-table__pagination-info" }, et = { class: "cf-table__pagination-controls" }, tt = ["disabled"], at = ["disabled"], lt = /* @__PURE__ */ v({
  __name: "CfDataTable",
  props: {
    columns: {},
    rows: {},
    loading: { type: Boolean, default: !1 },
    rowKey: {},
    emptyText: { default: "No data available" },
    pagination: {},
    ariaLabel: {},
    onRowClick: {}
  },
  emits: ["sort-change", "page-change"],
  setup(e, { emit: s }) {
    const c = s, o = V(null), f = V("asc");
    function d(l) {
      o.value === l ? f.value = f.value === "asc" ? "desc" : "asc" : (o.value = l, f.value = "asc"), c("sort-change", l, f.value);
    }
    return (l, _) => (t(), a("div", Pe, [
      l.$slots.toolbar ? (t(), a("div", Ke, [
        b(l.$slots, "toolbar", {}, void 0, !0)
      ])) : r("", !0),
      i("div", Ee, [
        i("table", {
          class: "cf-table",
          "aria-label": e.ariaLabel
        }, [
          i("thead", xe, [
            i("tr", null, [
              (t(!0), a(y, null, g(e.columns, (n) => (t(), a("th", {
                key: n.key,
                class: $(["cf-table__th", { "cf-table__th--sortable": n.sortable }]),
                style: I(n.width ? { width: n.width } : void 0),
                onClick: (B) => n.sortable ? d(n.key) : void 0
              }, [
                w(u(n.label) + " ", 1),
                n.sortable ? (t(), a("span", Ge, u(o.value === n.key ? f.value === "asc" ? "↑" : "↓" : "↕"), 1)) : r("", !0)
              ], 14, Fe))), 128)),
              l.$slots.actions ? (t(), a("th", He, "Actions")) : r("", !0)
            ])
          ]),
          i("tbody", Oe, [
            e.loading ? (t(), a("tr", We, [
              i("td", {
                colspan: e.columns.length + (l.$slots.actions ? 1 : 0),
                class: "cf-table__td cf-table__td--center"
              }, " Loading… ", 8, je)
            ])) : e.rows.length ? (t(!0), a(y, { key: 2 }, g(e.rows, (n, B) => (t(), a("tr", {
              key: e.rowKey ? String(n[e.rowKey]) : B,
              class: $(["cf-table__row", { "cf-table__row--clickable": !!e.onRowClick }]),
              onClick: (p) => {
                var M;
                return (M = e.onRowClick) == null ? void 0 : M.call(e, n);
              }
            }, [
              (t(!0), a(y, null, g(e.columns, (p) => (t(), a("td", {
                key: p.key,
                class: "cf-table__td"
              }, [
                b(l.$slots, `cell:${p.key}`, k({ ref_for: !0 }, { row: n, value: n[p.key] }), () => [
                  w(u(n[p.key]), 1)
                ], !0)
              ]))), 128)),
              l.$slots.actions ? (t(), a("td", Xe, [
                b(l.$slots, "actions", k({ ref_for: !0 }, { row: n }), void 0, !0)
              ])) : r("", !0)
            ], 10, Ue))), 128)) : (t(), a("tr", Je, [
              i("td", {
                colspan: e.columns.length + (l.$slots.actions ? 1 : 0),
                class: "cf-table__td cf-table__td--center"
              }, u(e.emptyText), 9, Qe)
            ]))
          ])
        ], 8, Ae)
      ]),
      e.pagination ? (t(), a("div", Ye, [
        i("span", Ze, " Page " + u(e.pagination.page) + " of " + u(Math.ceil(e.pagination.total / e.pagination.pageSize) || 1) + " (" + u(e.pagination.total) + " total) ", 1),
        i("div", et, [
          i("button", {
            class: "cf-table__page-btn",
            disabled: e.pagination.page <= 1,
            onClick: _[0] || (_[0] = (n) => l.$emit("page-change", e.pagination.page - 1))
          }, " ‹ Prev ", 8, tt),
          i("button", {
            class: "cf-table__page-btn",
            disabled: e.pagination.page * e.pagination.pageSize >= e.pagination.total,
            onClick: _[1] || (_[1] = (n) => l.$emit("page-change", e.pagination.page + 1))
          }, " Next › ", 8, at)
        ])
      ])) : r("", !0)
    ]));
  }
}), _t = /* @__PURE__ */ h(lt, [["__scopeId", "data-v-8d2cd318"]]);
export {
  de as CfBadge,
  it as CfButton,
  dt as CfCard,
  _t as CfDataTable,
  nt as CfInput,
  rt as CfModal,
  ft as CfProgressBar,
  ct as CfSelect,
  bt as CfSidebar,
  ut as CfToast
};
